import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';

export const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        maxWidth: 396,
        background:'#2A374E',
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '6px',
        fontSize: '14px',
        color: 'white' ,
        padding:'6px 16px',
    },
}))(Tooltip);
